import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { setUserDetailsState } from '../../../redux/slices/authSlice';
import { setAlertText, setSeverity, setToast } from '../../../redux/slices/commonComponentSlice';
import Cookies from 'js-cookie';
import { auth } from '../../../redux/slices/authSlice';

import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
  Link,
  Divider
} from '@mui/material';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const redirectParam = searchParams.get('redirect');
  const decodedRedirect = redirectParam ? decodeURIComponent(redirectParam) : null;
  const fallbackRedirect = sessionStorage.getItem('post_login_redirect');
  const redirectTarget = decodedRedirect || fallbackRedirect || null;
  const token = useSelector(auth).token;
  const handleSignup = (event) => {
  event.preventDefault();
  // window.location.href = 'https://app.liquid.diamonds/#/registration';
  window.location.href = `${process.env.REACT_APP_API_URL}/#/registration`;
};

 const handleLogin = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');

  try {
    // const response = await fetch('https://app.liquid.diamonds/sessions', {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/sessions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': true,
      },
      body: JSON.stringify({
        session: {
          email,
          password
        }
      })
    });

    const data = await response.json();
    // console.log('Login response:', data);

    if (response.ok && data.api_key.access_token) {
      const token = data.api_key.access_token;
      Cookies.set('access_token', token, { expires: 7 }); // store token for 7 days

      // Fetch user profile
      const profileResponse = await fetch(`${process.env.REACT_APP_API_URL}/my_profile`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'ngrok-skip-browser-warning': true,
        },
      });

      const profileData = await profileResponse.json();
      // console.log('Profile response:', profileData);

     
      if (profileResponse.ok && profileData.data) {
        dispatch(setUserDetailsState({
          details: profileData.data,
          token,
        }));
        const isAccount552 = String(profileData?.data?.account_id) === "552" || String(profileData?.data?.account_id) === "1";
        if (isAccount552) {
          sessionStorage.removeItem('post_login_redirect');
          navigate('/stock_performance', { replace: true });
          return;
        }
        if (redirectTarget && redirectTarget.startsWith('/')) {
        // clean up so we don't re-use stale redirect later
        sessionStorage.removeItem('post_login_redirect');
        navigate(redirectTarget, { replace: true });
        return; // stop here — no backend redirect call needed
      }
        dispatch(setToast(true));
        dispatch(setAlertText('Login successful!'));
        dispatch(setSeverity('success'));

        // ✅ Step: Fetch redirect URL from server
        const redirectResponse = await fetch(`${process.env.REACT_APP_API_URL}/redirect_to_react`, {
          method: 'GET',
          cache: 'no-store',
          headers: {
            Authorization: `Bearer ${token}`,
            'ngrok-skip-browser-warning': true,
          },
        });

        const redirectData = await redirectResponse.json();
        console.log('Redirect response:', redirectData);

        if (redirectResponse.ok && redirectData.redirect_url) {
          // window.location.href = redirectData.redirect_url; // ✅ redirect to the dynamic URL from backend
          // navigate(redirectData.redirect_url); // ✅ navigate to the dynamic URL from backend
          // Use client navigation for same-origin paths; full reload otherwise
          try {
            const url = new URL(redirectData.redirect_url, window.location.origin);
            if (url.origin === window.location.origin) {
              navigate(url.pathname + url.search, { replace: true });
            } else {
              window.location.href = redirectData.redirect_url;
            }
          } catch {
            navigate(redirectData.redirect_url, { replace: true });
          }
        } else {
          // fallback in case /redirect_to_react fails
          navigate(`/subscribe?access_token=${token}`, { replace: true });
        }

      } else {
        throw new Error('Failed to fetch user profile');
      }
    } else {
      throw new Error(data.error || 'Login failed');
    }
  } catch (err) {
    // console.error('Login error:', err);
    setError(err.message || 'Login failed. Please try again.');

    dispatch(setToast(true));
    dispatch(setAlertText(err.message || 'Login failed. Please try again.'));
    dispatch(setSeverity("error"));
  } finally {
    setLoading(false);
  }
};


  return (
    <div className='mx-auto w-full px-2 bg-white flex justify-between items-center h-full'>
    <div className=' w-[480px] mx-auto py-2'>
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ padding: 6, width: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
          <img
              src="assets/img/LD_logo_banner_long_dark_bg.png"
              alt=""
              className="image-cl mb-10"
            />
            
            <h2 className='self-start font-bold mb-2'>
              Sign in
            </h2>
          
            
            {error && (
              <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
                {error}
              </Alert>
            )}

            <Box component="form"  sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: 1,
            }}>
              <TextField
                margin="normal"
                required
                fullWidth
                size="small"
                id="email"
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: 14,   // change input text size
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: 13,   // change label size
                  },
                }}
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
              <TextField
                margin="none"
                size="small"
                required
                fullWidth
                name="password"
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: 14,   // change input text size
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: 13,   // change label size
                  },
                }}
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
                
              />
              <button
                onClick={handleLogin}
                disabled={loading}
                type="submit"
                  className="border-[1px] rounded-sm font-medium mt-1 text-[0.85rem] border-transparent h-8 bg-[#1E90FF] text-white  px-3 gap-[0.200rem] flex justify-center items-center"
                >
                {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : 'Sign In'}
              </button>
              {/* <Button
                type="submit"
                fullWidth
                variant="contained"
              >
                {loading ? <CircularProgress size={24} /> : 'Sign In'}
              </Button> */}
             
              <Link
                // component="button"
                // type="button"
                // onClick={handleForgotPassword}
                href="https://app.liquid.diamonds/#/forgot_password"
                variant="body2"
                sx={{ alignSelf: 'center', fontSize: '0.8rem', fontWeight: 'medium'}}
              >
                Forgot your password?
              </Link>
            <Divider>or</Divider>
              
            </Box>
            <Box sx={{ display: 'flex', width: '100%',flexDirection: 'column', gap: 2 }}>
           {/* <Button
                fullWidth
                variant="outlined"
                sx={{
                    mt: 2,
                    mb: 2,
                    backgroundColor: 'white',
                    color: '#1565C0',
                    borderColor: 'gray',
                    '&:hover': {
                    backgroundColor: '#f5f5f5', 
                    borderColor: 'gray',
                    },
                }}
                onClick={handleSignup}
                >
                Sign Up
            </Button> */}

              <button
                onClick={handleSignup}
                disabled={loading}
                type="button"
                  className="border-[1px] mt-2 rounded-sm bg-transparent font-medium  text-[0.85rem] border-[#1E90FF] h-8 text-[#1E90FF]  px-3 gap-[0.200rem] flex justify-center items-center"
                >
                Sign Up
              </button>
            {/* <Typography sx={{ textAlign: 'center' }}>
              Don&apos;t have an account?{' '}
              <Link
                href="/material-ui/getting-started/templates/sign-in/"
                
                variant="body2"
                sx={{ alignSelf: 'center' }}
              >
                Sign up
              </Link>
            </Typography> */}
          </Box>
          </Box>
        </Paper>
      </Box>
    </div>
   </div> 
  );
};

export default Login;
